import { FaLinkedin } from "react-icons/fa"

export default FaLinkedin
